import React from "react";
import { bool, func, array, object, string } from "prop-types";

import Notifications from "../Notifications";
import Icon from "../../../icons";
import AuthView from "../../../rows/AuthView";

import "./newHeader.m.css";

const BellContainer = ({
  dot,
  showNotifications,
  toggleNotifications,
  notifications,
  showLogin,
  loginBorderStyle,
  loginTextStyle,
  bellIconStyle,
}) => (
  <>
    <div styleName={`bell-container ${dot ? "new-notifications" : "no-notifications"}`}>
      <span styleName="bell" onClick={toggleNotifications}>
        {" "}
        <Icon type="bell" className="bell" iconStyle={{ fill: bellIconStyle }} />
      </span>
      {showNotifications && <Notifications closeView={toggleNotifications} notifications={notifications} />}
    </div>
    {showLogin && <AuthView borderColor={loginBorderStyle} textColor={loginTextStyle} />}
  </>
);

BellContainer.propTypes = {
  dot: bool,
  showNotifications: bool,
  toggleNotifications: func,
  notifications: array,
  showLogin: bool,
  loginBorderStyle: object,
  loginTextStyle: string,
  bellIconStyle: string,
};

export default BellContainer;
